export default "/_next/static/009826cd4ad988806e9605064f4ed0bd.png";